module.exports = {"type":"Typ","ic":"IČ/RČ","name":"Název/Jméno","address":"Adresa","rowDt":"Datum vložení","insertDate":"Datum vložení"}